export * from "modules/DealerDetails/components/Configuration";
export * from "modules/DealerDetails/components/DealerDetailsActions";
export * from "modules/DealerDetails/components/DealerDetailsHeader";
export * from "modules/DealerDetails/components/DmsSystem";
export * from "modules/DealerDetails/components/GdprAvg";
export * from "modules/DealerDetails/components/General";
export * from "modules/DealerDetails/components/Invoicing";
export * from "modules/DealerDetails/components/PonOil";
export * from "modules/DealerDetails/components/Service";
